import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=6fa731da&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa731da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa731da')) {
      api.createRecord('6fa731da', component.options)
    } else {
      api.reload('6fa731da', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=6fa731da&scoped=true&", function () {
      api.rerender('6fa731da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HJMsOZtSTc2m/JS/comp/Voucher-Unit.vue"
export default component.exports